var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPowerlessIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 70,
    viewBox: "0 0 69 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 68.0045C53.0015 68.0045 68 53.005 68 34.5022C68 15.9995 53.0015 1 34.5 1C15.9985 1 1 15.9995 1 34.5022C1 53.005 15.9985 68.0045 34.5 68.0045Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4494 34.502C55.4494 34.502 48.5101 46.0243 55.4494 46.0243C62.3886 46.0243 55.4494 34.502 55.4494 34.502Z",
    fill: "#00ADEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2288 11.0605C30.2288 11.0605 31.485 16.8517 26.3763 20.1899C26.3763 20.1899 22.0811 22.9778 17.5586 19.3045C17.5586 19.3045 26.2566 20.8958 30.2288 11.0605Z",
    fill: "#231F20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7713 11.0605C38.7713 11.0605 37.515 16.8517 42.6238 20.1899C42.6238 20.1899 46.919 22.9778 51.4415 19.3045C51.4415 19.3045 42.7434 20.8958 38.7713 11.0605Z",
    fill: "#231F20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7775 53.2155C48.6648 45.9646 42.2878 40.377 34.4991 40.377C26.7103 40.377 20.3453 45.9527 19.2207 53.1916C25.8011 50.4037 37.0954 47.6876 49.7655 53.2155H49.7775Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7637 26.2363C15.7637 26.2363 24.2583 24.6329 29.9892 31.9675C29.9892 31.9675 25.6342 30.9744 18.7428 35.8323",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7637 26.2363C15.7637 26.2363 24.2583 24.6329 29.9892 31.9675C29.9892 31.9675 25.6342 30.9744 18.7428 35.8323",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2353 26.2363C53.2353 26.2363 44.7407 24.6329 39.0098 31.9675C39.0098 31.9675 43.3648 30.9744 50.2562 35.8323",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2353 26.2363C53.2353 26.2363 44.7407 24.6329 39.0098 31.9675C39.0098 31.9675 43.3648 30.9744 50.2562 35.8323",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerlessIcon);
export default __webpack_public_path__ + "static/media/powerless-icon.8de8422e9a15b516f1a5bfeba99980fd.svg";
export { ForwardRef as ReactComponent };